import { render } from "./ItemList.vue?vue&type=template&id=6d4d4b2a&scoped=true"
import script from "./ItemList.vue?vue&type=script&lang=js"
export * from "./ItemList.vue?vue&type=script&lang=js"

import "./ItemList.vue?vue&type=style&index=0&id=6d4d4b2a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Pablo Sastre\\OneDrive\\Escritorio\\BAIPManagerTestv2\\BaipMarket.Dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d4d4b2a"]])

export default __exports__